import React from "react";

/* eslint-disable max-len */
export default function cineonstudioIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 370.1 54.2"
            xmlSpace="preserve"
        >
            <path fill="#16ADC1" d="M328.7 13.3H335.5V53.8H328.7z" />
            <defs>
                <path id="a" d="M0 0H370.1V54.2H0z" />
            </defs>
            <clipPath id="b">
                <use xlinkHref="#a" overflow="visible" />
            </clipPath>
            <g clipPath="url(#b)">
                <path
                    fill="#16ADC1"
                    d="M332.1 6.9c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4M293.7 40.3c0 7.4 6 13.5 13.4 13.5s13.4-6 13.4-13.4V.3h-6.8v15.2c-6.4-3.7-14.6-1.4-18.3 5-1.1 2-1.7 4.2-1.8 6.4v.2l.1 13.2zm6.7-13.3c0-3.7 3-6.6 6.6-6.6s6.6 3 6.6 6.6v13.2c0 3.7-3 6.6-6.6 6.6s-6.6-3-6.6-6.6V27zM356.5 13.3c-7.5 0-13.5 6.1-13.5 13.5v13.5c.1 7.5 6.2 13.5 13.6 13.4 7.4-.1 13.3-6 13.4-13.4V26.8c.1-7.4-6-13.5-13.5-13.5m6.7 15.2v11.7a6.7 6.7 0 01-13.4 0V26.8a6.7 6.7 0 0113.4 0v1.7z"
                />
                <path
                    fill="#FFF"
                    d="M79.6 27.1c0-7.4-6-13.4-13.4-13.4s-13.4 6-13.4 13.4V54h6.8V27c0-3.7 3-6.6 6.6-6.6 3.7 0 6.6 3 6.6 6.6v27h6.8V27.1M188.4 27.2c0-7.4-6-13.4-13.4-13.4s-13.4 6-13.4 13.4V54h6.8V27c0-3.7 3-6.6 6.6-6.6 3.7 0 6.6 3 6.6 6.6v27h6.8V27.2c0 .1 0 .1 0 0"
                />
                <path fill="#FFF" d="M36.5 13.6H43.3V54.1H36.5z" />
                <path
                    fill="#FFF"
                    d="M39.9 7.2c-1.9 0-3.4-1.5-3.4-3.4S38 .4 39.9.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4M20.2 40.5a6.7 6.7 0 01-13.4 0V27.1a6.7 6.7 0 0113.4 0H27c0-7.5-6.1-13.5-13.5-13.5S0 19.6 0 27.1v13.5C.1 48 6.2 54 13.6 53.9c7.4 0 13.4-6 13.4-13.4h-6.8zM138.6 13.6c-7.5 0-13.5 6.1-13.5 13.5v13.5c.1 7.5 6.2 13.5 13.6 13.4 7.4-.1 13.3-6 13.4-13.4V27.1c0-7.5-6-13.5-13.5-13.5m6.7 15.1v11.7a6.7 6.7 0 01-13.4 0V27.1a6.7 6.7 0 0113.4 0v1.6zM116.1 27.1c0-7.5-6-13.5-13.5-13.5s-13.5 6-13.5 13.5v13.6c0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5v-.1h-6.8c-.1 3.7-3.1 6.6-6.8 6.6-3.6-.1-6.6-3-6.6-6.6V34h20.2v-6.9m-6.8 0H95.9V27c0-3.7 3-6.7 6.7-6.7s6.7 3.1 6.7 6.8"
                />
                <path
                    fill="#16ADC1"
                    d="M197.7 48.1l4.2-5.3c2.6 2.6 6.1 4.3 9.4 4.3 3.8 0 6.7-1.7 6.7-4.4 0-2.9-3.1-4.3-6.4-5.7l-4.9-2.2c-3.7-1.6-8-4.2-8-9.8 0-6.3 5.8-11.1 13.3-11.1 4.4 0 8.6 1.8 11.6 4.9l-3.7 4.8c-2.1-2-4.9-3.1-7.8-3.2-3.2 0-6.2 1.5-6.2 4.1 0 2.8 3.5 4 6.6 5.3l4.8 2.1c4.5 1.9 8 4.6 8 10.2 0 6.3-5.6 11.7-14.1 11.7-5.1-.1-9.9-2.1-13.5-5.7M234.6 39.3V19.9h-5.2v-6.7h5.3l.2-13.2h7v13.2h7.6v6.7h-7.9V36c-.1 2.4 0 4.7.3 7.1.1 1.3.8 2.5 1.8 3.3.8.5 1.8.7 2.8.7.8 0 1.6 0 2.4-.1v6.7c-2 .2-4 .1-6-.1s-3.9-1-5.5-2.3c-3-3-2.8-8.2-2.8-12M284.5 40.3c0 7.4-6 13.4-13.4 13.4s-13.4-6-13.4-13.4V13.7h6.8v26.7c0 3.7 3 6.6 6.6 6.6 3.7 0 6.6-3 6.6-6.6V13.7h6.8v26.6"
                />
            </g>
        </svg>
    );
}
